import { render } from "./aio-login-pro-branding.vue?vue&type=template&id=673a029e&scoped=true"
import script from "./aio-login-pro-branding.vue?vue&type=script&lang=js"
export * from "./aio-login-pro-branding.vue?vue&type=script&lang=js"

import "./aio-login-pro-branding.vue?vue&type=style&index=0&id=673a029e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673a029e"]])

export default __exports__